import { useAgencyCampaignContext } from '../../agencyCampaignContext';
import { AgencyCampaignSection, AgencyEditorMode } from '../../../agency/model';
import { Link } from '@tanstack/react-router';
import { Copy, Edit3 } from 'lucide-react';
import { DashboardTableRowActionItem, DashboardTableRowActions } from '@shigo-ui/dashboard-ui';

import { dashboardT } from '../../../../lib/messages';
import { CreativeTab, type Creative } from '../model';

export function CreativeActions({
  creative,
  tab,
  brandId,
  pending,
  onDuplicate,
}: {
  creative: Creative;
  tab: CreativeTab;
  brandId: string;
  pending: boolean;
  onDuplicate: () => void;
}) {
  const scope = useAgencyCampaignContext();
  const editTo =
    tab === CreativeTab.Display
      ? '/campaigns/creatives/display/edit/$creativeId'
      : '/campaigns/creatives/video/edit/$creativeId';
  return (
    <DashboardTableRowActions label={dashboardT('creatives.actions')} pending={pending}>
      <DashboardTableRowActionItem asChild>
        <Link
          to={scope ? '/a/$agencyId/campaigns/$section' : editTo}
          params={{
            creativeId: creative.id,
            agencyId: scope?.agency.id ?? '',
            section: AgencyCampaignSection.Creatives,
          }}
          search={{
            brand: brandId,
            ...(scope ? { editor: AgencyEditorMode.Edit, id: creative.id, creativeTab: tab } : {}),
          }}
        >
          <Edit3 className="h-4 w-4" />
          {dashboardT('creatives.edit')}
        </Link>
      </DashboardTableRowActionItem>
      <DashboardTableRowActionItem disabled={pending} onSelect={onDuplicate}>
        <Copy className="h-4 w-4" />
        {dashboardT('creatives.duplicate')}
      </DashboardTableRowActionItem>
    </DashboardTableRowActions>
  );
}
